import { useMutation, useQuery } from '@tanstack/react-query'
import * as axios from 'axios'

const MEMBERSHIP_API_BASE = 'https://membership.uibfs.or.ug/uib-api'

export interface EligibleBenefitMember {
  applicationId: number
  memberId: string
  memberName: string
  email?: string
  phone?: string
  alreadyAwarded: boolean
  awardedPoints: number
}

export function useBenefitEligibleMembers(benefitId: string | number | undefined, enabled: boolean) {
  return useQuery({
    queryKey: ['benefit-eligible-members', benefitId],
    enabled: enabled && Boolean(benefitId),
    queryFn: async () => {
      const response = await axios.default.get<EligibleBenefitMember[]>(
        `${MEMBERSHIP_API_BASE}/membership/benefits/${benefitId}/eligible-members`,
      )
      return response.data
    },
  })
}

export function useAwardBenefitMembers(benefitId: string | number) {
  return useMutation({
    mutationFn: async (applicationIds: number[]) => {
      const response = await axios.default.post(
        `${MEMBERSHIP_API_BASE}/membership/benefits/${benefitId}/awards`,
        { applicationIds },
      )
      return response.data
    },
  })
}
